import { Badge, ConfigProvider, Empty, List, Typography } from "antd";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { PageData } from "../declarations";

const Main: React.FC<{ pages: PageData[] }> = ({ pages }) => {
    useEffect(() => {
        if ((window as any).PMA) {
            document.title = "Home - PMA.UI Examples " + (window as any).PMA.UI.getVersion();
        }
        else{
            document.title = "Home - PMA.UI Examples";
        }
    }, []);

    const capitalize = (str: string) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    const getRibbonColor = (str: string) => {
        switch (str) {
            case "basic":
                return "#93ce77";
            case "advanced":
                return "#e4d782";
            case "expert":
                return "#f1767d";
            default:
                return "#7f9dc3";
        }
    }

    return (
        <div className="site-layout-content">
            <ConfigProvider renderEmpty={() => <Empty description="No examples found." />}>
                <List
                    grid={{
                        gutter: 16,
                        xs: 1,
                        sm: 2,
                        md: 2,
                        lg: 3,
                        xl: 3,
                        xxl: 3,
                    }}
                    dataSource={pages}
                    renderItem={item => (
                        <List.Item key={item.link}>
                            <Badge.Ribbon text={capitalize(item.tags[0])} color={getRibbonColor(item.tags[0])}>
                                <Link to={item.link} className="example bg-light border rounded">
                                    <Typography.Title level={5} style={{ marginBottom: "0" }}>{item.title}</Typography.Title>
                                    <Typography.Text italic style={{ fontSize: "smaller" }}>{item.link}</Typography.Text>
                                    <Typography.Paragraph className="description">{item.shortdesc}</Typography.Paragraph>
                                </Link>
                            </Badge.Ribbon>
                        </List.Item>
                    )}
                />
            </ConfigProvider>
        </div>);
}

export default Main;